export const CS_URL = 'https://www.citysprint.co.uk'
export const DATE_FORMAT = 'DD/MM/YY'
export const DATE_WEEKDAY_FORMAT = 'ddd DD/MM/YY'
export const TIME_FORMAT = 'HH:mm'
export const DATE_TIME_FORMAT = 'ddd DD/MM/YY - HH:mm'
export const endpoints = {
    trackingDetails: (customer: string, trackingId: string) =>
        `${process.env.REACT_APP_APIGEE_URL}/citybridge-proxy/v1/tracking-details/${customer}/${trackingId}`,
}
export const LONDON_LOCATION = {
    lat: 51.51,
    lng: -0.13,
}
export const breakpoints = {
    lg: '(min-width: 1024px)',
    md: '(min-width: 768px)',
    sm: '(min-width: 640px)',
}

export const JOB_STATUS = {
    pickup: 'Pickup',
    completed: 'COMPLETED',
    collected: 'Collected',
    deliver: 'Deliver',
    arrivedAt: 'ArrivedAt',
    accept: 'Accept',
}
